import React from "react";
import { apolloClient } from "@services/graphql2";
import { ApolloProvider } from "@apollo/client";
import {
  AuthProvider,
  CartProvider,
  LoadingScreenProvider,
  SessionProvider,
} from "@providers";

/* This provider is the global app provider */

export const _AppProvider: React.FC = ({ children }) => {
  return (
    <ApolloProvider client={apolloClient}>
      <LoadingScreenProvider>
        <SessionProvider>
          <CartProvider>
            <AuthProvider>{children}</AuthProvider>
          </CartProvider>
        </SessionProvider>
      </LoadingScreenProvider>
    </ApolloProvider>
  );
};
